export default __webpack_public_path__ + "static/media/left_arrow.45fce116.svg";